export default "__VITE_ASSET__Bnkq7pZN__"